import { useMemo, useState } from 'react'
import { errorHandler } from '../../../../../services/util/error.service'
import * as TransferHttp from '../../../../../services/api/https/deliveries/delivery-transfer.http'
import {
  convertToFormatedDateString,
  getPeriodoFromLastXDays,
} from '../../../../../services/util/date.service'
import { gerarArquivoExcel } from '../../../../../services/util/excel.service'

const INITIAL_STATE = {
  entregas: [],
  entregasOriginais: [],
  entregasSelecionadas: [],
  isContentLoading: false,
  empresaSelecionada: [],
  tpSelecionado: [],
  empresas: [],
  tps: [],
  errorMessage: null,
  successMessage: null,
  isBtnLoading: false,
  selecionarTodos: false,
  periodo: getPeriodoFromLastXDays(31),
  activeIndex: 0,
  modal: { show: false, data: null },
  modalDisponivel: { show: false, data: null },
}

export const MENU_ITEMS_NAMES = ['Detalhes por Empresa']

export default function useCargasParadasTransferencia() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      resetMessages() {
        setState(prevState => ({ ...prevState, errorMessage: null, successMessage: null }))
      },
      limpar() {
        setState(prevState => {
          prevState.empresaSelecionada = []
          prevState.tpSelecionado = []
          prevState.selecionarTodos = false
          prevState.entregas = prevState.entregasOriginais
          return { ...prevState }
        })
      },
      async fetchDeliveriesToBeTransferred(selectedTp, periodo) {
        try {
          setState(prevState => ({ ...prevState, isContentLoading: true }))
          const entregas = await TransferHttp.getCargasParadasTransferencia(selectedTp, periodo)

          setState(prevState => ({
            ...prevState,
            entregas,
            entregasOriginais: entregas,
            entregasSelecionadas: [],
            isContentLoading: false,
            empresas: getEmpresas(entregas),
            tps: getTps(entregas),
          }))
        } catch (error) {
          setState(prevState => ({
            ...prevState,
            isContentLoading: false,
            errorMessage: errorHandler(error),
          }))
        }
      },

      onFormDataChange(fieldName, value) {
        switch (fieldName) {
          case 'empresaSelecionada':
            setState(prevState => {
              const entregas = filtrarEntregas(
                value,
                prevState.tpSelecionado,
                prevState.entregasOriginais,
              )
              return { ...prevState, entregas, empresaSelecionada: value }
            })
            break
          case 'tpSelecionado':
            setState(prevState => {
              const entregas = filtrarEntregas(
                prevState.empresaSelecionada,
                value,
                prevState.entregasOriginais,
              )
              return { ...prevState, entregas, tpSelecionado: value }
            })
            break
          default:
            break
        }
      },

      onChangePeriodo(pInicial, pFinal) {
        setState(prevState => ({
          ...prevState,
          periodo: { pInicial, pFinal },
        }))
      },

      onMenuItemClicked(item, data) {
        switch (item) {
          case 'Detalhes por Empresa':
            setState(prevState => ({
              ...prevState,
              modal: { show: true, data },
            }))
            break
          default:
            break
        }
      },

      closeModal() {
        setState(prevState => ({
          ...prevState,
          modal: { show: false, data: null },
        }))
      },

      openModalDisponivel(entrega) {
        setState(prevState => ({
          ...prevState,
          modalDisponivel: { show: true, data: entrega },
        }))
      },

      closeModalDisponivel() {
        setState(prevState => ({
          ...prevState,
          modalDisponivel: { show: false, data: null },
        }))
      },

      async saveAvailableToTransfer(delivery_id, available_to_transfer, transfer_not_available_reason, selectedTp, periodo) {
        try {
          setState(prevState => ({ ...prevState, isBtnLoading: true }))
          await TransferHttp.updateAvailableToTransfer(delivery_id, available_to_transfer, transfer_not_available_reason)
          setState(prevState => ({
            ...prevState,
            isBtnLoading: false,
            successMessage: 'Disponibilidade para transferência atualizada com sucesso',
            modalDisponivel: { show: false, data: null },
          }))
          const entregas = await TransferHttp.getCargasParadasTransferencia(selectedTp, periodo)
          setState(prevState => ({
            ...prevState,
            entregas,
            entregasOriginais: entregas,
            entregasSelecionadas: [],
            empresas: getEmpresas(entregas),
            tps: getTps(entregas),
          }))
        } catch (error) {
          setState(prevState => ({
            ...prevState,
            isBtnLoading: false,
            errorMessage: errorHandler(error),
          }))
        }
      },

      onTabChange(index) {
        setState(prevState => ({
          ...prevState,
          activeIndex: index,
        }))
      },

      setEntregasSelecionadas(value) {
        setState(prevState => ({ ...prevState, entregasSelecionadas: value }))
      },

      onBtnExportarClick(entregasSelecionadas) {
        if (!entregasSelecionadas || entregasSelecionadas.length === 0) {
          setState(prevState => ({ ...prevState, errorMessage: 'Nenhuma entrega selecionada' }))
          return
        }

        const colunas = [
          [
            'Criada Em',
            'Razão Social',
            'Cidade',
            'Identificador',
            'Empresa',
            'Destino',
            'Qte. Volumes',
            'Peso Bruto',
            'Disponível',
            'Status',
          ],
        ]

        entregasSelecionadas.forEach(e => {
          const isAvailable = e.available_to_transfer === 1 || e.available_to_transfer === true
          colunas.push([
            convertToFormatedDateString(e.created_at),
            e.razao_social,
            `${e.city} - ${e.uf_sigla}`,
            e.identifier,
            e.company_name,
            e.tp_name,
            e.qte_sku,
            e.weightTotal,
            isAvailable ? 'Sim' : 'Não',
            e.status,
          ])
        })

        gerarArquivoExcel('Cargas Paradas', colunas, 'cargas_paradas.xlsx')
      },
    }
  }, [])

  return { state, localDispatch }
}

function filtrarEntregas(selectedEmpresa, selectedTp, entregasOriginais) {
  const empresasIds = selectedEmpresa.map(e => e.id)
  const tpsIds = selectedTp.map(e => e.id)
  let entregasFiltradas = entregasOriginais
  if (!empresasIds.length && tpsIds.length) {
    entregasFiltradas = entregasOriginais.filter(e => tpsIds.includes(e.tp_id))
  } else if (empresasIds.length && !tpsIds.length) {
    entregasFiltradas = entregasOriginais.filter(e => empresasIds.includes(e.company_id))
  } else if (empresasIds.length && tpsIds.length) {
    entregasFiltradas = entregasOriginais.filter(
      e => empresasIds.includes(e.company_id) && tpsIds.includes(e.tp_id),
    )
  }
  return entregasFiltradas
}

function getEmpresas(entregas) {
  const empresasIds = new Set(entregas.map(e => e.company_id))
  const empresas = []
  empresasIds.forEach(empresa_id => {
    const entrega = entregas.find(e => e.company_id === empresa_id)
    entrega && empresas.push({ id: entrega.company_id, name: entrega.company_name })
  })
  return empresas
}
function getTps(entregas) {
  const tpsIds = new Set(entregas.map(e => e.tp_id))
  const tps = []
  tpsIds.forEach(tp_id => {
    const entrega = entregas.find(e => e.tp_id === tp_id)
    entrega && tps.push({ id: entrega.tp_id, name: entrega.tp_name })
  })
  return tps
}
